export default __webpack_public_path__ + "static/N0007-73d7459020c6b94cfa3ab694bbb41135.png";